

<div class="dashboard">
    <div class="dashboard-body">
        <div class="dashboard-topbar">
            <div class="user-card">
                <div class="user">
                    <img src="assets/images/user.png" alt="">
                </div>
                <!-- <h4>
                    Luqta
                </h4>
                <small>Client</small> -->
            </div>
        </div>
        <app-subscription></app-subscription>
    </div>
</div>